/**
 * 권한 상수와 판정.
 *
 * 문자열은 서버 `internal/domain/rbac.go` 와 **같은 값**입니다 — 한쪽만 바꾸면 메뉴가 조용히
 * 사라지거나(판정 실패) 없는 화면이 보이다 403 이 납니다.
 *
 * ⚠️ 여기서의 판정은 **UX 용**입니다. 권한의 정본은 서버이고 모든 엔드포인트가 자기 권한을
 * 직접 검사합니다(`PermissionGuard`). 이 파일의 역할은 "메뉴에 없는 화면을 열어 403 을 보는"
 * 경험을 없애는 것뿐입니다.
 */

import type { Session } from "./types";

export const PERM = {
  memberManage: "plt:member:manage",
  roleAssign: "plt:role:assign",
  siteRead: "plt:site:read",
  siteManage: "plt:site:manage",
  apiKeyIssue: "plt:apikey:issue",
  apiKeyIssueUnlimited: "plt:apikey:issue_unlimited",
  apiKeyRevoke: "plt:apikey:revoke",
} as const;

export type Permission = (typeof PERM)[keyof typeof PERM];

export const can = (session: Session | null, perm: Permission): boolean =>
  Array.isArray(session?.permissions) && session.permissions.includes(perm);
